import { createFileRoute } from "@tanstack/react-router";
import { OnboardingPage } from "@/features/onboarding";

const Route = createFileRoute("/_authorized/onboarding")({
  component: () => <OnboardingPage />,
});

export { Route };
